import LoginForm from "./login_form/login_form.jsx";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Footer from "../../components/Footer/Footer.jsx";
import AlertModal from "../../components/AlertModal/AlertModal.jsx";
import { useModalBase } from "../../hooks/useModalBase.js";
import styles from "./index.module.css";
import InputModal from "../../components/inputModal/inputModal.jsx";
import Loading from "../../components/loadingModal/LoadingModal.jsx";
import {
  openLoading,
  closeLoading,
} from "../../components/loadingModal/loading.js";
import useLogin from "../../hooks/useLogin.js";
import logo from "../../assets/loggin/loggin-asset.png";

const Login = () => {
  const [isOpen, openModal, closeModal] = useModalBase();
  const [modalCont, setModalCont] = useState({
    title: "",
    text: "",
  });
  const [isOpenRP, openModalRP, closeModalRP] = useModalBase();
  const mediaQuery = window.matchMedia("(max-width: 427px)");
  const { sessionExpired, loggedUser, confirmIsAuth, resetPassword } =
    useLogin();
  const navigate = useNavigate();

  const getInitialData = () => {
    openLoading();
    confirmIsAuth()
      .then(() => {
        if (loggedUser.isLogged) {
          navigate("/home");
        }
      })
      .catch((error) => {
        if (error?.status === "503") {
          navigate("/404");
        }

        if (sessionExpired) {
          setModalCont({
            title: "SESSION EXPIRED",
            text: "Your session has expired, please log in again",
          });
          openModal();
        }
        closeLoading();
      });
  };

  useEffect(() => {
    getInitialData();
  }, []);

  const handleRecoverPassword = async (e) => {
    openLoading();
    const email = e;
    const response = await resetPassword(email);
    if (response.status === "Successfully") {
      setModalCont({
        title: "SUCCESS",
        text: "Your username and password have been sent to your email",
      });
      openModal();
      closeModalRP();
    } else {
      setModalCont({
        title: "ERROR",
        text: response.message,
      });
      openModal();
      closeModalRP();
    }
    closeLoading();
  };

  if (mediaQuery.matches) {
    return (
      <div className={styles.container}>
        <Loading />
        <AlertModal
          isOpen={isOpen}
          closeModal={() => {
            localStorage.removeItem("sessionExpired");
            closeModal();
          }}
          title={modalCont.title}
          text={modalCont.text}
        />
        <InputModal
          isOpen={isOpenRP}
          onSubmit={handleRecoverPassword}
          closeModal={closeModalRP}
          title="PLEASE PROVIDE YOUR EMAIL TO RECOVER YOUR USERNAME/PASSWORD"
        />
        <div className={styles.contentMovile}>
          <div className={styles.singin}>
            <div className={styles.headerTitle}>CUSTOMER PORTAL</div>
            <LoginForm
              openModal={openModal}
              openModalRP={openModalRP}
              setModalCont={setModalCont}
            />
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className={styles.container}>
        <Loading />
        <AlertModal
          isOpen={isOpen}
          closeModal={() => {
            localStorage.removeItem("sessionExpired");
            closeModal();
          }}
          title={modalCont.title}
          text={modalCont.text}
        />
        <InputModal
          isOpen={isOpenRP}
          onSubmit={handleRecoverPassword}
          closeModal={closeModalRP}
          title="PLEASE PROVIDE YOUR EMAIL TO RECOVER YOUR USERNAME/PASSWORD"
        />
        {loggedUser.outOfService ? (
          <Navigate to="/404" />
        ) : (
          loggedUser.isLogged && <Navigate to="/home" />
        )}
        <div>
          <div className={styles.content}>
            <div className={styles.logoContainer}>
              <img src={logo} alt="Logo" className={styles.logo} />
            </div>
            <div className={styles.singin}>
              <LoginForm
                openModal={openModal}
                openModalRP={openModalRP}
                setModalCont={setModalCont}
              />
            </div>
          </div>
          <span className={styles.helper}>
            By continuing, you agree to our{" "}
            <Link
              to={`/terms-of-service?ref=home`}
              style={{ color: "#724BAE", fontFamily: "ProximaNova-Bold" }}
            >
              Terms of Service
            </Link>{" "}
            and{" "}
            <Link
              to={`/end-user-license-agreement?ref=home`}
              style={{ color: "#724BAE", fontFamily: "ProximaNova-Bold" }}
            >
              End User License Agreement
            </Link>
            .
          </span>
        </div>
        <div className="con-foo">
          <Footer />
        </div>
      </div>
    );
  }
};

export default Login;
